import React from 'react';

import QuizContext from './context';

export const useQuizContext = () => {
  const context = React.useContext(QuizContext);
  if (context === undefined) {
    throw new Error('useQuizContext must be used within a QuizProvider');
  }
  return context;
};
